import React, { Component } from 'react';
import * as _ from 'lodash';
import './AddTeamModalContent.scss';
import { PermissionCheckboxList } from '../../../../../shared/permission-checkbox-list/PermissionCheckboxList';
import { LabeledInput } from '../../../../../shared/labeled-input/LabeledInput';
import { LabeledTextarea } from '../../../../../shared/labeled-textarea/LabeledTextarea';
import { BlueContainedButton } from '../../../../../shared/button/blue-contained-button/BlueContainedButton';

export class AddTeamModalContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: null,
            description: null,
            permissions: [],
            brands: [],
            jurisdictions: []
        };
    }

    onAddTeam = () => {
        _.isFunction(this.props.addTeam) && this.props.addTeam(this.state);
    };

    handleNameInputChange = name => {
        this.setState({
            ...this.state,
            name
        });
    };

    handleDescriptionInputChange = description => {
        this.setState({
            ...this.state,
            description
        });
    };

    handlePermissionsChange = permissions => {
        this.setState({
            ...this.state,
            permissions
        });
    };

    isAddButtonDisabled = () => {
        return (
            !this.state.name ||
            !this.state.description ||
            !this.state.permissions ||
            !this.state.permissions.length
        );
    };

    render = () => (
        <div className={'add-team-modal-content'}>
            <div className={'add-team-fields'}>
                <LabeledInput
                    value={this.state.name}
                    label={'Name'}
                    onChange={this.handleNameInputChange}
                    className={'add-team row'}
                />
                <LabeledTextarea
                    value={this.state.description}
                    label={'Description'}
                    onChange={this.handleDescriptionInputChange}
                    className={'add-team row'}
                />
                <div className={'add-team row'}>
                    <span className={'select-label'}>Permissions</span>
                    <PermissionCheckboxList
                        onChange={this.handlePermissionsChange}
                    />
                </div>
            </div>
            <BlueContainedButton
                text={'Add Team'}
                onClick={() => this.onAddTeam()}
                disabled={this.isAddButtonDisabled()}
            />
        </div>
    );
}
